import { render, staticRenderFns } from "./requestDetails.vue?vue&type=template&id=05144703&"
import script from "./requestDetails.vue?vue&type=script&lang=js&"
export * from "./requestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports